import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {connect} from "react-redux";
import {Icon} from "semantic-ui-react";
import {
    openEditCountryPricingModalV2,
    toggleDeleteCountryPriceModalV2
} from "../actions/PricingTablesActions";

const COUNTRIES = require("../../../common/resources/countries.json");

export class CountryPricingRowV2 extends React.Component {

    state = {
        isHovered: false,
    }

    static propTypes = {
        countryRecord: PropTypes.object,
        pricingID: PropTypes.string
    }

    countryLabel = (code) => {
        return _.result(_.find(COUNTRIES, {
            'value': code
        }), 'label');
    }

    get country() {
        const {countryRecord} = this.props;
        const countryCode = countryRecord.country_code;
        return (
            countryCode + ' - ' + this.countryLabel(countryCode)
        );
    }

    get countryPrices() {
        const {countryRecord} = this.props;
        const countryPrice = countryRecord.pricing_json;
        return (
            countryPrice.map((price, idx) => (
                <td key={idx}>{price.price}</td>
            ))
        )
    }

    handleEditCountryPricing = () => {
        this.props.openEditCountryPriceModal(this.props.countryRecord);
    }

    handleDeleteCountryPricing = () => {
        this.props.toggleDeleteCountryPriceModal(this.props.countryRecord.country_pricing_id);
    }

    get editDelete() {
        return (
            <td className={"edit-records"}>
                <Icon link
                      name="pencil alternate"
                      onClick={this.handleEditCountryPricing}
                />
                <Icon link
                      name="trash alternate outline"
                      onClick={this.handleDeleteCountryPricing}
                />
            </td>
        );
    }

    render() {
        const { countryRecord, canEdit } = this.props;
        return (
            <tr key={countryRecord.pricing_id}>
                <td>{this.country}</td>
                {this.countryPrices}
                {canEdit && this.editDelete}
            </tr>
        )
    }
}


const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isPricingAdmin,
});

const mapDispatchToProps = dispatch => ({
    openEditCountryPriceModal: (countryRecord) => {dispatch(openEditCountryPricingModalV2(countryRecord))},
    toggleDeleteCountryPriceModal: (countryPricingID) => {dispatch(toggleDeleteCountryPriceModalV2(countryPricingID))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CountryPricingRowV2)
